import React from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import Button from '../../components/Button/Button';

const Container = styled.div`
  max-width: 480px;
  margin: 64px auto 0 auto;
  text-align: center;
  padding: 32px 16px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.06);
`;

const Title = styled.h1`
  font-size: 2rem;
  margin-bottom: 1rem;
  color: #22223b;
`;

const Message = styled.p`
  font-size: 1.1rem;
  color: #4a4e69;
  margin-bottom: 0;
`;

const HomeLink = styled(Link)`
  text-decoration: none;
  text-align: center;
  color: #fff;
`;

const CancelPage: React.FC = () => {
  const intl = useIntl();
  return (
    <Container>
      <Title>{intl.formatMessage({ id: 'subscriptionCancel.title' })}</Title>
      <Message>
        {intl.formatMessage({ id: 'subscriptionCancel.message' })}
      </Message>
      <Button>
        <HomeLink to="/">
          {intl.formatMessage({ id: 'subscriptionCancel.goHome' })}
        </HomeLink>
      </Button>
    </Container>
  );
};

export default CancelPage;
